<ng-container *ngIf="isModalWindow">
  <sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="true"></sub-header>
  <p-scrollPanel [style]="{width: '100%', height: '75vh'}" styleClass="custombar1" *ngIf="isLoaded()">
    <ng-container *ngTemplateOutlet="CONTENT"></ng-container>
  </p-scrollPanel>
</ng-container>
<ng-container *ngIf="!isModalWindow">
  <div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
    <ng-container *ngTemplateOutlet="CONTENT"></ng-container>
  </div>
</ng-container>
<ng-template #CONTENT>
  <div class="container-fluid m-b-lg">
    <div class="alert alert-info row col-12" *ngIf="!existsAuditData()">
      <span><i class="fas fa-info-circle mr-2" aria-hidden="true"></i>{{ 'General.noData' | translate }}</span>
    </div>
    <div class="row m-t-md m-1" *ngIf="existsAuditData()">
      <div class="col-12 p-0">
        <span *ngIf="!procedure" class="float-left leyenda">{{ 'Audit.dossier' | translate }}</span>
        <span *ngIf="procedure" class="float-left leyenda">{{ 'Audit.audit' | translate }} <i>{{ procedure.description
            }}</i>
        </span>
        <span class="float-right leyenda"> {{ 'Tasks.showing' | translate }} {{ filteredAuditList ?
          filteredAuditList.length : '0' }} </span>
      </div>
    </div>
    <div class="row m-1" *ngIf="existsAuditData()">
      <div class="col-12 p-0">
        <input type="text" class="p-inputtext col-12" placeholder="{{ 'General.filterPlaceholder' | translate }}"
          name="filterText" id="filterTextInput" [(ngModel)]="textFilter" (ngModelChange)="updateFilter()"
          aria-controls="DataTables_Table_2" autocomplete="off" />
      </div>
    </div>
    <div class="m-t-xs filterHeader row m-1" *ngIf="existsAuditData()">
      <div class="col-12 p-0">
        <!-- <span class="font-bold col-12 col-sm-2">{{'General.filters'|translate}}:
      </span> -->
        <span class="  col-12 col-sm-4">
          <p-checkbox binary="true" label="{{ 'Audit.pending.text' | translate }}" [(ngModel)]="pendingTasksFilter"
            (ngModelChange)="updateFilter()" class="btn btn-filter"></p-checkbox>
        </span>
        <span class="  col-12 col-sm-4" *ngIf="procedureId">
          <p-checkbox binary="true" label="{{ 'Audit.internalProcesses' | translate }}" [(ngModel)]="internalProcesses"
            (ngModelChange)="load()" class="btn btn-filter"></p-checkbox>
        </span>
      </div>
    </div>
    <div class="row m-t-md m-1  m-b-lg" *ngIf="existsAuditData()">
      <div class="col-12  m-b-lg">
        <p-table [value]="filteredAuditList" sortField="dateArrival" sortOrder="1" [rows]="20" [paginator]="true"
          [pageLinks]="4" [rows]="20" [scrollable]="false" responsiveLayout="scroll" >
               <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
              <col style="width: 200px">
              <col style="width: 120px">
              <col style="width: 120px">
              <col style="width: 120px">
            </colgroup>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="7"> {{ 'General.noData' | translate }} </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="description" class="text-left p-t-md p-b-md LONGTEXTTH">{{ 'Audit.task' | translate
                }} <p-sortIcon field="description">
                </p-sortIcon>
              </th>
              <th pSortableColumn="user" class="USERTH">{{ 'General.user' | translate }} <p-sortIcon field="user">
                </p-sortIcon>
              </th>
              <th pSortableColumn="dateArrival" class="DATETH  ">{{ 'PendingTasks.arrival' | translate }} <p-sortIcon
                  field="dateArrival"></p-sortIcon>
              </th>
              <th pSortableColumn="dateDesp" class="DATETH  ">{{ 'Audit.dispatched' | translate }} <p-sortIcon
                  field="dateDesp"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-element>
            <tr>
              <td field="description" class="text-left p-t-md p-b-md LONGTEXTTH">
                <p-overlayPanel #taskTooltip appendTo="body" [dismissable]="true" [showCloseIcon]="true">
                  <dl class="dl-horizontal">
                    <dt>
                      <i class="fa fa-archive"></i> {{ 'Audit.task' | translate }}
                    </dt>
                    <dd>{{ element.description }}</dd>
                    <dt *ngIf="element.user">{{ 'General.user' | translate }}</dt>
                    <dd *ngIf="element.user; else inboxName">
                      <user [user]="element.user"></user>
                    </dd>
                    <ng-template #inboxName>
                      <dt>{{ 'Audit.box' | translate }}</dt>
                      <dd>{{ element.inbox ? element.inbox.name : "element.identifier" }}</dd>
                    </ng-template>
                    <dt *ngIf="element.dateArrival"> {{ 'Audit.arrival' | translate }} </dt>
                    <dd *ngIf="element.dateArrival"> {{ element.dateArrival | date: 'dd/MM/yyyy HH:mm' }} </dd>
                    <dt *ngIf="element.dateOpen"> {{ 'Audit.open' | translate }} </dt>
                    <dd *ngIf="element.dateOpen"> {{ element.dateOpen | date: 'dd/MM/yyyy HH:mm' }} </dd>
                    <dt>{{ 'Audit.dispatched' | translate }}</dt>
                    <dd *ngIf="element.dateDesp"> {{ element.dateDesp | date: 'dd/MM/yyyy HH:mm' }} </dd>
                    <dd *ngIf="!element.dateDesp" [ngClass]="{ 'text-warning': !element.dateDesp }"> Tarea Pendiente
                    </dd>
                    <dt *ngIf="element.taskId"> {{ 'Audit.identifier' | translate }} </dt>
                    <dd *ngIf="element.taskId">{{ element.taskId }}</dd>
                    <dt *ngIf="element.procedureId" class="small "> {{ 'Audit.reference' | translate }} </dt>
                    <dd *ngIf="element.procedureId" class="small "> {{ element.procedureId }} - {{ element.swIdTask }}
                    </dd>
                  </dl>
                </p-overlayPanel>
                <a (click)="taskTooltip.toggle($event)">
                  <span class="progress">
                    <i *ngIf="element.dateDesp"
                      class=" {{ element.taskId.startsWith('R~')?' fas fa-share ':' fa fa-check ' }}  text-muted m-r-md "
                      pTooltip="{{this.getStatusTooltip(element)}}"></i>
                    <i *ngIf="!element.dateDesp" class="fas fa-play  text-success m-r-md"></i></span>
                  <span class="{{ element.dateDesp?' text-muted ': ' font-weight-bold ' }}  "
                    pTooltip="{{ element.description }}" tooltipPosition="bottom">{{ element.description }}</span>
                </a>
              </td>
              <td field="user" class="USERTH">
                <user *ngIf="element.user" [user]="element.user"></user>
                <ng-container *ngIf="!element.user">
                  <!--i class="fa fa-inbox"></i-->
                  <button class="btn btn-sm btn-outline-primary w-100" aria-expanded="false"
                    title="{{ 'General.visualize' | translate}}" (click)="showInbox(element)">
                    <i class="fas fa-inbox" aria-hidden="true"> </i>
                    <span class="d-none d-sm-inline"> {{ element.inbox ? element.inbox.name : "?" }}</span>
                  </button>
                </ng-container>
              </td>
              <td field="dateArrival" class="DATETH  ">
                <span *ngIf="element.dateArrival">{{ element.dateArrival | date: 'dd/MM/yyyy HH:mm ' }}</span>
              </td>
              <td field="dateDesp" class="DATETH  ">
                <span *ngIf="element.dateDesp">{{ element.dateDesp | date: 'dd/MM/yyyy HH:mm ' }}</span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</ng-template>